export default {"src":"/_next/static/media/stop-pressed.429a3f30.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};